<template>
    <div>
        <Empty image="search" description="404页面" >
            <template slot="description">
                <div style="line-height: 26px">
                    <h2>404</h2>
                    <h4>NOT FOUND</h4>
                    <h3>很抱歉</h3>
                    <!-- <h4>您找的页面飞走了！</h4> -->
                    <h4>请到pc端处理</h4> 
<!--                    <van-button round type="info" @click="toback(-1)" style="margin-top: 20px;">返回上一页</van-button>-->
                </div>
            </template>
        </Empty>
    </div>
</template>

<script>
    import {Empty} from 'vant';

    export default {
        name: "notfund",
        components: {
            Empty
        }
    }
</script>
